import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  TextField,
  IconButton,
  InputAdornment,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import ApiService from "../../services/categoryManagementApi";

const { LanguageApi } = ApiService;

export default function AddLanguage({ show, onHide, id, fetchLanguageData }) {
  const [newLanguage, setNewLanguage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      fetchLanguageById();
    } else {
      setNewLanguage(""); // Reset field if adding a new language
    }
  }, [id]);

  const fetchLanguageById = async () => {
    setLoading(true);
    try {
      const res = await LanguageApi.getById({id});
      if (res.status === 200) {
        setNewLanguage(res.data?.data?.name || "");
      } else {
        toast.error("Failed to fetch language data");
      }
    } catch (error) {
      toast.error("An error occurred while fetching language data");
    } finally {
      setLoading(false);
    }
  };

  const handleSaveLanguage = async () => {
    if (!newLanguage.trim()) {
      toast.error("Language name is required");
      return;
    }

    setLoading(true);
    try {
      let res;
      if (id) {
const payload = {
    id,
    name: newLanguage
}
        res = await LanguageApi.edit(payload);
        if (res.status === 200) {
            fetchLanguageData();
          toast.success("Language updated successfully");
        } else {
          toast.error("Failed to update language");
        }
      } else {
        // Add new language
        res = await LanguageApi.add({ name: newLanguage });
        if (res.status === 200) {
            fetchLanguageData()
          toast.success("Language added successfully");
        } else {
          toast.error("Failed to add language");
        }
      }
      onHide();
    } catch (error) {
      toast.error("An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={show} onClose={onHide} >
      <DialogTitle >
        {id ? "Edit Language" : "Add Language"}
        <IconButton
          aria-label="close"
          onClick={onHide}
          sx={{ position: "absolute", right: 10, top: 10 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent style={{paddingTop : "12px", width : "400px"}}>
        <TextField
          fullWidth
          label="Language Name"
          variant="outlined"
          value={newLanguage}
          onChange={(e) => setNewLanguage(e.target.value)}
        />
      </DialogContent>
      <DialogActions style={{ marginBottom : "12px", marginRight: "14px"}}>
        <Button variant="contained" onClick={handleSaveLanguage} disabled={loading}>
          {loading ? "Saving..." : id ? "Update" : "Add"}
        </Button>
        <Button variant="outlined" onClick={onHide}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
